
import React from 'react';
import { BUSINESS_INFO } from '../constants';
import { FileText, Shield, Gavel } from 'lucide-react';

const TermsConditions: React.FC = () => {
  return (
    <div className="bg-transparent min-h-screen py-20 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-white p-8 md:p-16 rounded-[3rem] shadow-2xl border border-slate-50 reveal-up">
          <div className="flex items-center space-x-4 mb-12">
            <div className="bg-slate-900 p-4 rounded-2xl shadow-xl shadow-slate-900/20">
              <FileText className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900">Terms of Service</h1>
          </div>
          
          <div className="space-y-10 text-slate-600 leading-relaxed text-lg">
            <p className="text-xl">By using the {BUSINESS_INFO.name} website, you agree to comply with the following governing terms:</p>
            
            <div className="grid gap-6">
              {[
                { 
                  title: "Informational Use Only", 
                  content: "All content provided is for general wellness purposes and does not constitute professional advice or clinical diagnosis." 
                },
                { 
                  title: "Service Modification", 
                  content: "We reserve the right to update or discontinue any products or services at our discretion without prior notice." 
                },
                { 
                  title: "User Responsibility", 
                  content: "Users must provide accurate, lawful, and current information when communicating with our business channels." 
                },
                { 
                  title: "Intellectual Property", 
                  content: "All website content, including logos and text, is protected by copyright. Unauthorized use is strictly prohibited." 
                },
                { 
                  title: "Liability Limitation", 
                  content: "We are not responsible for any misuse of information or results arising from the use of third-party platforms linked here." 
                }
              ].map((term, i) => (
                <div key={i} className="flex space-x-6 p-6 rounded-3xl bg-slate-50 hover:bg-white border border-transparent hover:border-slate-100 transition-all group">
                  <div className="flex-shrink-0 w-10 h-10 bg-white shadow-sm border border-slate-200 rounded-full flex items-center justify-center font-bold text-teal-600 group-hover:bg-teal-600 group-hover:text-white transition-all">
                    {i + 1}
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1">{term.title}</h4>
                    <p className="text-sm">{term.content}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-slate-900 p-10 rounded-[2.5rem] text-white relative overflow-hidden mt-16">
              <Gavel className="absolute top-0 right-0 w-32 h-32 opacity-10 -translate-y-1/2 translate-x-1/2" />
              <h3 className="text-xl font-bold mb-4 flex items-center">
                <Shield className="w-5 h-5 mr-3 text-teal-400" /> Jurisdiction
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                These terms are governed by the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of the courts in Jabalpur, Madhya Pradesh.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
